import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Landing from "./Landing";
import PageNotFoundView from "./PageNotFoundView";
import DealFlow from "./DealFlow/DealFlow";
import DealFlowSpecial from "./DealFlow/DealFlowSpecial";
import DealFlowDebug from "./DealFlow/DealFlowDebug";
import DealFlowConfirmation from "./DealFlow/DealFlowConfirmation";
import PolicyPage from "./DealFlow/PolicyPage";
import { FirebaseProvider } from "./utils/FirebaseContext";
import { DealsProvider } from "./utils/DealsContext";

function App() {
  const location = useLocation();
  const isDevRoute = location.pathname.startsWith("/dev/");
  const searchParams = new URLSearchParams(location.search);
  const isDealFlowDebugMode = searchParams.get("debug") === "1";
  const dealFlowElement = isDealFlowDebugMode ? <DealFlowDebug /> : <DealFlow />;

  useEffect(() => {
    const isDealFlowRoute =
      location.pathname.startsWith("/dealflow") || location.pathname.startsWith("/dev/dealflow");
    document.body.classList.toggle("dealflow-route", isDealFlowRoute);

    return () => {
      document.body.classList.remove("dealflow-route");
    };
  }, [location.pathname]);

  return (
    <FirebaseProvider>
      <DealsProvider>
        {isDevRoute && (
          <div className="app-dev-badge" aria-label="Development environment">
            DEV MODE
          </div>
        )}
        {isDealFlowDebugMode && (
          <div className="app-debug-badge" aria-label="Debug mode">
            DEBUG MODE
          </div>
        )}
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/dealflow" element={dealFlowElement} />
          <Route path="/dev/dealflow" element={dealFlowElement} />
          <Route path="/dealflow/special" element={<DealFlowSpecial />} />
          <Route path="/dev/dealflow/special" element={<DealFlowSpecial />} />
          <Route path="/dealflow/confirmation" element={<DealFlowConfirmation />} />
          <Route path="/dev/dealflow/confirmation" element={<DealFlowConfirmation />} />
          <Route
            path="/dealflow/terms"
            element={
              <PolicyPage
                title="Dealflow Terms of Service"
                markdownPath="/dealflow-terms-of-service.md"
              />
            }
          />
          <Route
            path="/dev/dealflow/terms"
            element={
              <PolicyPage
                title="Dealflow Terms of Service"
                markdownPath="/dealflow-terms-of-service.md"
              />
            }
          />
          <Route
            path="/dealflow/privacy"
            element={
              <PolicyPage
                title="Dealflow Privacy Policy"
                markdownPath="/dealflow-privacy-policy.md"
              />
            }
          />
          <Route
            path="/dev/dealflow/privacy"
            element={
              <PolicyPage
                title="Dealflow Privacy Policy"
                markdownPath="/dealflow-privacy-policy.md"
              />
            }
          />
          <Route path="/*" element={<PageNotFoundView />} />
        </Routes>
      </DealsProvider>
    </FirebaseProvider>
  );
}

export default App;
